// extracted by mini-css-extract-plugin
export default {"label":"CurrencyInput__label--+-DpN","error":"CurrencyInput__error--dYQFO","inputCurrency":"CurrencyInput__inputCurrency--88EFO","currencyCode":"CurrencyInput__currencyCode--c0H7q"};